<script setup>
import {computed} from "vue";

const props = defineProps(['show', 'title', 'body', 'options', 'modalClass'])
const emit = defineEmits(['clicked']);
const showModal = computed({
    get() {
        return props.show;
    },

    set(value) {
        emit('update:show', value);
    }
});

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" :title="title" :modal-class="modalClass ?? 'modal-w-sm'">
        <p>
            {{ body }}
        </p>

        <template #modal-footer>
            <div style="display: flex; align-items: center; justify-content: space-between; width: 90%;">
                <b-button
                    v-for="option in options"
                    :key="option.value"
                    :variant="option.variant ?? 'primary'"
                    :class="option.class ?? ''"
                    @click="emit('clicked', option.value)"
                >
                    {{ option.label }}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<style lang="scss">
@import "../../assets/stylesheets/colors";

.modal-w-sm .btn-danger {
    background-color: $dark-red;
    border-color: $dark-red;
}

.btn {
    font-weight: bold !important;
}

.btn-white {
    border-color: #e5e5e5 !important;
    background-color: #fff !important;
    color: #000 !important;
}
</style>